// extracted by mini-css-extract-plugin
module.exports = {"Component":"AppSlideTab_Component__2syXG","TabItem":"AppSlideTab_TabItem__3vHPv","TabItemActive":"AppSlideTab_TabItemActive__32hfp","Glider":"AppSlideTab_Glider__1yIES"};